module.exports = __webpack_public_path__ + "img/shikai.60bb142d.png";